
















































import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import '@/compiled-icons/chart-line';
import VueApexCharts from 'vue-apexcharts';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {ApexOptions} from 'apexcharts';

@Component({
  components: {
    VueApexCharts
  }
})
export default class ApexChartsTemplate extends Vue {
  @Prop({required: true}) apexChartsVisualisationButtonsConfiguration!: DisguiseDto.ApexChartsVisualisationButtonsConfiguration;
  @Prop({required: true}) inputConfiguration!: DisguiseDto.DTInputConfigurationDto;

  // data to be displayed
  chartType: DisguiseDto.EnumApexChartsTypes = 'line';
  series: DisguiseDto.ApexChartsSeries[] = [];

  // inital
  apexChartsDefaultConfiguration: ApexOptions = {
    chart: {
      id: 'chart'
    },
    series: [],
    noData: {
      text: 'Loading...'
    },
    theme: {
      mode: this.$vuetify.theme.dark ? 'dark' : 'light'
    }
  };

  private getApexData(url: string) {
    // reset
    this.series = [];
    const dturl = url + (url.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize(this.inputConfiguration);

    HTTP_SERVICE_INSTANCE.getAxios()
        .get<DisguiseDto.ApexChartsJsonConfiguration>(dturl)
        .then((response) => {

          this.series = response.data.series || [];
          this.apexChartsDefaultConfiguration = response.data.options || {};
          this.chartType = response.data.types || 'line';
        })
        .catch(() => {
          this.$store.commit('showSnack', {
            message: 'Daten konnten nicht geladen werden',
            color: 'error'
          });
        });
  }

}

